import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'transformUnderscoreToSpace',
  standalone: true
})
export class TransformUnderscoreToSpacePipe implements PipeTransform {
  transform(str: string): string {
    if (str && str.length > 0) {
      return str.replace(/_/g, ' ');
    } else {
      return str;
    }
  }
}
